export const Cookies = {
    AuthKey: "authKey",
}